import { render, staticRenderFns } from "./ProjectPlannedResourcesResponsibleAndSubscribersAddModal.vue?vue&type=template&id=3fa06e2b&scoped=true&"
import script from "./ProjectPlannedResourcesResponsibleAndSubscribersAddModal.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannedResourcesResponsibleAndSubscribersAddModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlannedResourcesResponsibleAndSubscribersAddModal.vue?vue&type=style&index=0&id=3fa06e2b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa06e2b",
  null
  
)

export default component.exports